import { Routes } from "@angular/router";
import { AdminGuard } from "../guard/admin.guard";

export const content: Routes = [
  {
    path: "kim-cuong",
    loadChildren: () =>
      import(
        "../../modules/diamond-management/diamond-management.module"
      ).then((m) => m.DiamondManagementModule),
  },
  {
    path: "trang-suc-kim-cuong",
    loadChildren: () =>
      import(
        "../../modules/diamond-jewelry-management/diamond-jewelry-management.module"
      ).then((m) => m.DiamondJewelryModule),
  },
  {
    path: "users",
    loadChildren: () =>
      import("../../modules/users/users.module").then((m) => m.TablesModule),
    canActivate: [AdminGuard],
  },
  {
    path: "wishlist",
    loadChildren: () =>
      import("../../modules/wishlist/wishlist.module").then((m) => m.WishlistModule),
  },
  {
    path: "lich-hen",
    loadChildren: () =>
      import("../../modules/appointment/appointment.module").then((m) => m.AppointmentModule),
  },
  {
    path: "landing-page",
    loadChildren: () =>
      import("../../modules/page-config/page-config.module").then((m) => m.PageConfigModule),
  },
  {
    path: "blogs",
    loadChildren: () =>
      import("../../modules/blogs/blogs.module").then((m) => m.BlogsModule),
  },
  {
    path: "settings",
    loadChildren: () =>
      import("../../modules/site-settings/site-settings.module").then((m) => m.SiteSettingsModule),
  },
  // Legacy paths – footer and currency now live together under /settings.
  {
    path: "footer-management",
    pathMatch: "full",
    redirectTo: "settings/footer",
  },
  {
    path: "footer-management/**",
    redirectTo: "settings/footer",
  },
  {
    path: "currency-management",
    pathMatch: "full",
    redirectTo: "settings/currency",
  },
  {
    path: "currency-management/**",
    redirectTo: "settings/currency",
  },
];

